import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnChanges,
    SimpleChanges,
    inject,
} from '@angular/core';
import { AuthService } from '@services';
import {
    DxButtonModule,
    DxDropDownButtonModule,
    DxToolbarModule,
} from 'devextreme-angular';
import {
    PermissionType,
    AccessType,
    EmptyCheckOutAction,
} from '@services/web-api-client';

interface MenuAction {
    id: EmptyCheckOutAction;
    text: string;
    icon: string;
}

@Component({
    selector: 'app-empty-check-out-toolbar',
    standalone: true,
    imports: [DxToolbarModule, DxButtonModule, DxDropDownButtonModule],
    templateUrl: './empty-check-out-toolbar.component.html',
})
export class EmptyCheckOutToolbarComponent implements OnChanges {
    @Input() number: string | null = null;
    @Input() action: EmptyCheckOutAction[] | null = null;
    @Input() isReadOnly: boolean = false;
    @Input() isSubmitting: boolean = false;
    @Input() isLoading: boolean = false;

    @Output() cancelClick = new EventEmitter<void>();
    @Output() shuntMoveClick = new EventEmitter<void>();
    @Output() save = new EventEmitter<EmptyCheckOutAction>();

    protected auth = inject(AuthService);
    protected moreMenuActions: MenuAction[] = [];
    public EmptyCheckOutAction = EmptyCheckOutAction;

    private readonly allMenuActions: MenuAction[] = [
        {
            id: EmptyCheckOutAction.ShuntMove,
            text: 'Shunt Move',
            icon: 'cursormove',
        },
        {
            id: EmptyCheckOutAction.Investigate,
            text: 'Investigate',
            icon: 'info',
        },
        {
            id: EmptyCheckOutAction.CancelMove,
            text: 'Cancel Move',
            icon: 'close',
        },
    ];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number'] || changes['action']) {
            this.buildMenuActions();
        }
    }

    private buildMenuActions(): void {
        if (this.isLoading) {
            this.moreMenuActions = [];
            return;
        }

        this.moreMenuActions = this.allMenuActions.filter((action) =>
            this.canShowButton(action.id),
        );
    }

    canShowButton(action: EmptyCheckOutAction): boolean {
        if (this.isLoading) return false;

        if (this.number && !this.isReadOnly && action === EmptyCheckOutAction.Save) {
            return true;
        }

        return this.action?.includes(action) ?? false;
    }

    get showMoreMenu(): boolean {
        return this.number !== null && this.moreMenuActions.length > 0;
    }

    onMenuActionClick(e: { itemData?: MenuAction }): void {
        if (!e.itemData) return;

        switch (e.itemData.id) {
            case EmptyCheckOutAction.ShuntMove:
                this.shuntMoveClick.emit();
                break;
            default:
                this.onButtonClick(e.itemData.id as EmptyCheckOutAction);
        }
    }

    onButtonClick(status: EmptyCheckOutAction) {
        this.save.emit(status);
    }
}
